module.exports = __webpack_public_path__ + "static/img/intel_property2.4cd44b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intel_property2.png
// module id = PDsN
// module chunks = 1